import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as dashboardManageAPI from 'api/Settings/dashboardManage';
import { openSnackbar } from 'store/reducers/snackbar';

const InitialState = {
  SetSelectvalue: null,
  AdminComponentData: null,
  AdminRoleData: null,
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init'
};

const getAdminRolecomponent = createAsyncThunk('DashboardManage/getAdminRolecomponent', async (params, { rejectWithValue }) => {
  try {
    const res = await dashboardManageAPI.getAdminRolecomponent(params);
    return res?.data?.data;
  } catch (error) {
    rejectWithValue(error);
  }
});

const getAdminMainRole = createAsyncThunk('DashboardManage/getAdminMainRole', async (params, { rejectWithValue }) => {
  try {
    const res = await dashboardManageAPI.getAdminMainRole(params);
    return res?.data?.data;
  } catch (error) {
    rejectWithValue(error);
  }
});

const saveGrid = createAsyncThunk('DashboardManage/saveGrid', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await dashboardManageAPI.saveGrid(params);
    dispatch(
      openSnackbar({
        open: true,
        message: res.data?.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: false
      })
    );
    return res?.data?.data;
  } catch (error) {
    dispatch(
      openSnackbar({
        open: true,
        message: error?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const DashboardManageSlice = createSlice({
  name: 'DashboardManage',
  initialState: InitialState,
  reducers: {
    resetState: () => {
      return InitialState;
    },
    selecteValue: (state, action) => {
      state.SetSelectvalue = action.payload;
    }
  },
  extraReducers: {
    [getAdminRolecomponent.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAdminRolecomponent.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.AdminComponentData = action.payload;
    },

    [getAdminRolecomponent.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAdminMainRole.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAdminMainRole.fulfilled]: (state, action) => {
      // console.log('features_data', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      state.AdminRoleData = action.payload;
    },

    [getAdminMainRole.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [saveGrid.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [saveGrid.fulfilled]: (state) => {
      // console.log('features_data', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
    },

    [saveGrid.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

export const { resetState, selecteValue } = DashboardManageSlice.actions;

export default DashboardManageSlice.reducer;

export { getAdminMainRole, getAdminRolecomponent, saveGrid };
